import React from 'react'
import Switch from '@material-ui/core/Switch'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useController } from 'react-hook-form'
import { HelperText } from '.'

export const HookSwitch = ({
  name,
  control,
  defaultValue = false,
  label,
  className,
  onChange,
  disabled,
  errorStyle
}) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue ?? false
  })

  const handleChange = (e) => {
    onChange?.(e)
    field.onChange(e)
  }

  return (
    <FormControl error={invalid}>
      <FormControlLabel
        control={
          <Switch
            className={className}
            disabled={disabled}
            checked={field.value}
            inputRef={field.ref}
            onBlur={field.onBlur}
            onChange={handleChange}
            inputProps={{
              'aria-label': label
            }}
            style={{
              '& .MuiSwitchSwitchBase.MuiChecked': {
                color: '#F67131'
              }
            }}
          />
        }
        label={label}
        classes={{
          label: className
        }}
        style={{ marginBottom: 0 }}
      />
      <HelperText invalid={invalid} error={error} style={errorStyle} />
    </FormControl>
  )
}